<template>
  <div>
    <v-card-title class="ma-0 px-3 pb-3 pt-0">
      <p class="blue-grey--text text--darken-3 h6 ma-0 pa-0">
        {{ $t('routines_reminder.set_reminder') }}
      </p>
    </v-card-title>

    <v-date-picker
      class="w-100 mb-4"
      :allowed-dates="allowedDates"
      :value="singleDateValue"
      no-title
      @change="$emit('onDateChange', $event)"
    />

    <HourSelector
      class="px-3 mb-4"
      icon="mdi-clock-outline"
      :selectedHour="selectedHour"
      @change="$emit('onHourChange', $event)"
    />

    <Button
      plain
      class="px-4 ms-2"
      icon="mdi-repeat"
      iconPosition="left"
      :text="$t('routines_reminder.set_repetition')"
      @click="$emit('setRepetition')"
    />
  </div>
</template>
<script>
import moment from 'moment'
import HourSelector from './HourSelector.vue'
import Button from '@/components/UI/Button.vue'

export default {
  name: 'DateSelectionStep',
  components: {
    HourSelector,
    Button,
  },

  props: {
    singleDateValue: {
      type: String,
    },
    selectedHour: { type: String },
  },
  computed: {
    allowedDates() {
      const today = moment().format('YYYY-MM-DD')
      return date => date >= today
    },
  },
}
</script>
